import { render, staticRenderFns } from "./coachingPlans.vue?vue&type=template&id=54ad7ae9&scoped=true&"
import script from "./coachingPlans.vue?vue&type=script&lang=js&"
export * from "./coachingPlans.vue?vue&type=script&lang=js&"
import style0 from "./coachingPlans.vue?vue&type=style&index=0&id=54ad7ae9&scoped=true&lang=css&"
import style1 from "./coachingPlans.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad7ae9",
  null
  
)

export default component.exports